import React from 'react';

const NOTIFICATION_OPTIONS = [
  {
    key: 'newBulletin',
    label: 'New Bulletins',
    description: 'Get notified when new bulletins are posted'
  },
  {
    key: 'newTicket',
    label: 'New Tickets',
    description: 'Get notified when new tickets are created'
  },
  {
    key: 'newForumPost',
    label: 'New Forum Posts',
    description: 'Get notified when new forum posts are created'
  },
  {
    key: 'newForumComment',
    label: 'Forum Comments',
    description: 'Get notified when someone comments on posts you follow'
  },
  {
    key: 'forumMention',
    label: 'Forum Mentions',
    description: 'Get notified when someone mentions you or your unit in the forum'
  }
];

function NotificationToggles({ preferences, onChange, disabled, variant = 'default' }) {
  const baseClasses = variant === 'bordered' 
    ? 'flex items-center gap-3 p-3 rounded-lg border border-border hover:bg-muted/50 cursor-pointer transition-colors'
    : 'flex items-center gap-3 cursor-pointer';

  return (
    <div className="space-y-3">
      {NOTIFICATION_OPTIONS.map((option) => (
        <label key={option.key} className={baseClasses}>
          <input
            type="checkbox"
            checked={preferences[option.key] ?? false}
            onChange={(e) => onChange({ ...preferences, [option.key]: e.target.checked })}
            className="w-5 h-5 rounded border-border text-primary focus:ring-primary"
            disabled={disabled}
          />
          <div className={variant === 'bordered' ? 'flex-1' : ''}>
            <span className="text-foreground font-medium">{option.label}</span>
            <p className="text-xs text-muted-foreground">{option.description}</p>
          </div>
        </label>
      ))}
    </div>
  );
}

export default NotificationToggles;
export { NOTIFICATION_OPTIONS };
